export default class ArticlePlacementForm {
  constructor({ html, errors, callback }) {
    this.newFormHtml = html;
    this.showErrors = errors;
    this.callback = callback;
    this.init();
  }

  init() {
    let $target = $('#details_form');

    if ($target.length > 0) {
      $target.hide();
      $target.html(this.newFormHtml)

      N2.hideProgressIndicator();

      this.callback()
      $target.show();
    }
  }
}
